import { Component, OnInit } from '@angular/core';
import { SetupService } from '@core/services/setup';

import { DEPARTMENT_TYPE_KIDS } from 'src/app/core/constants';

@Component({
    selector: 'app-kids-home',
    templateUrl: './kids-home.component.html',
    styleUrls: ['./kids-home.component.scss'],
})
export class KidsHomeComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto kids
     */
    public departmentType: string = DEPARTMENT_TYPE_KIDS;

    constructor(public setupService: SetupService) {}

    ngOnInit(): void {
        // this.registers = kidsService.getLastestNews().slice(0, 4);
        // this.totalRegisters = kidsService.getLastestNews().length;
    }
}
